// Module
var code = "<div ui=\"ui.mainNav\"></div> <section class=\"analytics\"> <header> <div> <h1>Analytics</h1> <p class=\"subtitle\">Information about your projects.</p> </div> </header> <section ui=\"ui.accountAnalytics\" class=\"content\"></section> </section> ";
// Exports
var _module_exports = code;;
var path = 'Analytics/Analytics.ng.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;